import styled from 'styled-components';
import { Theme } from '@material-ui/core/styles';

const IconWrapper = styled.div<{ theme: Theme }>`
  margin-right: ${({ theme }) => theme.spacing(2)}px;
`;
const IconLink = styled.a`
  cursor: pointer;
  /* aタグにグローバルでスタイルが当たっているため、それを回避するためのコード */
  text-decoration: none;
`;

const Styled = {
  IconWrapper,
  IconLink,
};

export default Styled;
